import { loadPublicFormSchema } from "@/lib/forms/publicForm";
import { formatNetworkQueryError } from "@/lib/http/formatQueryError";
import type { FormDto } from "@/types/form";
import { useAsyncResource } from "./useAsyncResource";

interface UseFormQueryResult {
  data?: FormDto;
  isLoading: boolean;
  error: string | null;
}

export function useFormQuery(
  formId: string | number | undefined,
): UseFormQueryResult {
  const validId = formId == null ? null : String(formId).trim() || null;

  const { data, isLoading, error } = useAsyncResource({
    enabled: validId != null,
    deps: [validId],
    fetch: () => loadPublicFormSchema(validId!),
    formatError: (err) =>
      formatNetworkQueryError(err, "Не удалось загрузить форму"),
    initialLoading: validId != null,
    clearOnDisabled: false,
  });

  if (validId == null) {
    return {
      data: undefined,
      isLoading: false,
      error: "Некорректный идентификатор формы",
    };
  }

  return { data, isLoading, error };
}
